(function () {
'use strict';

var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	};

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
		}

		scroll() {

			var scroll = window.scrollY;

			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				return;
			}

		}

	}

})(jQuery);

var documentInit$1 = documentInit;

var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	};

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	};

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

			console.log(this);

		}
		init() {
			this.$trigger = $(selectors.trigger);
			this.$links = $('a', this.$container).not(this.$trigger).not('[href="#"]');

			$('li', this.$container).filter((i, el) => {
				return ($(el).children('.sub-menu').children().length > 0 && $(el).closest('.sub-menu').length == 0);
			}).append('<div class="c-nav__item-arrow">');


			this.$dropdownTrigger = $('.c-nav__item-arrow', this.$container);
		}

		bind() {

			const self = this;

			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
			this.$dropdownTrigger.click(function () { self.toggleDropdown($(this)); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

		toggleDropdown($link) {
			if ($(window).width() < 900) {
				const $submenu = $link.siblings('.sub-menu');

				if ($submenu.is(":visible")) {
					$submenu.parent().removeClass('has-open');
				}
				else {
					$submenu.parent().addClass('has-open');
				}
				$submenu.stop().slideToggle(200);
			}
		}

	}

})(jQuery);


var mobileNavInit$1 = mobileNavInit;

var navInit;

(function ($) {

	const selectors = {
		navContainer: '.c-nav',
	};

	navInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new Nav(el);
		});
	};

	class Nav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$items = $(this.$container).children('li');
		}

		bind() {
			const self = this;
			this.onHover = this.onHover.bind(this);
			this.onHoverOut = this.onHoverOut.bind(this);
			this.$items.hover(function (e) { self.onHover(this); }, function (e) { self.onHoverOut(this); });
		}

		onHover(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeIn();
		}

		onHoverOut(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeOut();
		}

	}

})(jQuery);


var navInit$1 = navInit;

var slickInit;

const selectors = {
	'largeBannerSlider': '[data-banner-slider]',
	'imagesSectionSlider': '[data-images-slider]',
	'caseStudiesSlider': '[data-case-studies-slider]',
	'testimonialsSlider': '[data-testimonials-slider]',
	'prevArrow': '[data-prev-arrow]',
	'nextArrow': '[data-next-arrow]',
};

(function ($) {

	slickInit = function () {
		// new SlickSlider('.c-references', {
		// 	// fade: true,
		// 	autoplay: true,
		// 	autoplaySpeed: 5000,
		// 	speed: 1000,
		// 	arrows: true,
		// 	pauseOnHover: false,
		// 	dots: false,
		// 	loop: true,
		// 	mobileFirst: true,
		// 	prevArrow: '.c-references__arrow--prev',
		// 	nextArrow: '.c-references__arrow--next',
		// 	responsive: [
		// 		{
		// 			breakpoint: 600 - 1,
		// 			settings: {
		// 				slidesToShow: 2
		// 			}
		// 		},
		// 		{
		// 			breakpoint: 900 - 1,
		// 			settings: {
		// 				slidesToShow: 3
		// 			}
		// 		},
		// 	],
		// 	events: {
		// 		init: function (e, slick) {
		// 			setTimeout(_ => {
		// 				slick.$slides.eq(0).addClass('is-in-view');
		// 			}, 10);
		// 		},
		// 		beforeChange: function (e, slick, currentSlide, nextSlide) {
		// 			slick.$slides.eq(nextSlide).addClass('is-in-view');
		// 		},
		// 		afterChange: function (e, slick, currentSlide) {
		// 			slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
		// 		}
		// 	}
		// });

		$(selectors.largeBannerSlider).each((i, slider) => {

			const $slider = $(slider);

			new SlickSlider(slider, {
				// fade: true,
				autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: false,
				pauseOnHover: false,
				dots: false,
				loop: true,
				fade: true,
				mobileFirst: true,
				slidesToShow: 1,
				rows: 0,
			});

		});

		$(selectors.imagesSectionSlider).each((i, slider) => {

			const $slider = $(slider);
			const per_page = parseInt($slider.attr('data-per-page'));
			const num_slides = $slider.children().length;

			var $args = {
				// fade: true,
				// autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: true,
				pauseOnHover: false,
				dots: false,
				loop: true,
				rows: 0,
				mobileFirst: true,
				slidesToShow: 1,
				prevArrow: $(selectors.prevArrow, $slider.closest('section')),
				nextArrow: $(selectors.nextArrow, $slider.closest('section')),
				responsive: [
					{
						breakpoint: 600 - 1,
						settings: {
							slidesToShow: Math.ceil(per_page / 2),
						}
					},
				]
			};

			if (num_slides <= per_page) {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: 'unslick'
				});
			}
			else {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: per_page,
					}
				});
			}

			new SlickSlider(slider, $args);

		});

		$(selectors.caseStudiesSlider).each((i, slider) => {

			const $slider = $(slider);

			new SlickSlider(slider, {
				// fade: true,
				// autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: true,
				pauseOnHover: false,
				dots: false,
				loop: true,
				rows: 0,
				mobileFirst: true,
				slidesToShow: 1,
				prevArrow: $(selectors.prevArrow, $slider.closest('section')),
				nextArrow: $(selectors.nextArrow, $slider.closest('section')),
				responsive: [
					{
						breakpoint: 600 - 1,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 900 - 1,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 1200 - 1,
						settings: {
							slidesToShow: 4,
						}
					},
					{
						breakpoint: 1400 - 1,
						settings: 'unslick'
					},
				]
			});

		});

		$(selectors.testimonialsSlider).each((i, slider) => {

			const $slider = $(slider);
			const per_page = 2;
			const num_slides = $slider.children().length;

			var $args = {
				// fade: true,
				// autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: true,
				pauseOnHover: false,
				dots: false,
				loop: true,
				rows: 0,
				mobileFirst: true,
				slidesToShow: 1,
				prevArrow: $(selectors.prevArrow, $slider.closest('section')),
				nextArrow: $(selectors.nextArrow, $slider.closest('section')),
				responsive: []
			};

			if (num_slides <= per_page) {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: 'unslick'
				});
			}
			else {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: per_page,
					}
				});
			}

			new SlickSlider(slider, $args);

		});


	};

	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {

			this.onResize = this.onResize.bind(this);

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

		}

		init() {
			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}

})(jQuery);


var slickInit$1 = slickInit;

var miscInit;

(function ($) {

	const selectors = {
		scrollTop: '[data-scroll-top]',
	};

	miscInit = function () {

		$(selectors.scrollTop).click(function (e) {
			e.preventDefault();
			$('html, body').stop().animate({ scrollTop: 0 }, 1000);
		});

		$('a[href="#"]').on('click', (e) => { e.preventDefault(); });

		$('a[href^="#"]:not([href="#"])').on('click', function (e) {
			e.preventDefault();

			const target_id = $(this).attr('href').slice(1);
			const $target = $('#' + target_id + ', [data-id="' + target_id + '"]').filter(':visible');

			if ($target.length) {
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 80 }, 1000);
			}

		});

	};

})(jQuery);

var miscInit$1 = miscInit;

var csFiltersInit;

(function ($) {

	const selectors = {
		filters: '[data-cs-filters]',
		allFilter: '[data-cs-filter="all"]',
		filter: '[data-cs-filter]',
		grid: '[data-cs-grid]',
	};

	csFiltersInit = function () {
		$(selectors.filters).each((i, el) => {
			new CsFilters(el);
		});
	};

	class CsFilters {
		constructor(el) {

			this.$filtersWrap = $(el);

			this.init();
			this.bind();
		}

		init() {

			this.$wrap = this.$filtersWrap.closest('section');

			this.$allFilter = $(selectors.allFilter, this.$wrap);
			this.$filter = $(selectors.filter, this.$wrap).not(this.$allFilter);
			this.$grid = $(selectors.grid, this.$wrap);

			this.filtersChanged = false;

		}

		bind() {

			const self = this;

			this.resetFilters = this.resetFilters.bind(this);
			this.applyFilters = this.applyFilters.bind(this);

			this.$allFilter.on('click', (e) => { e.preventDefault(); self.resetFilters(); });
			this.$filter.on('change', () => { self.applyFilters(false); });
			$(window).on('hp-plugins-loaded', () => { self.applyFilters(true); });
			$(window).on('post-load', () => { self.$filtersWrap.removeClass('is-loading'); });
		}

		resetFilters() {
			this.$filter.each((i, el) => {
				if ($(el).find('[data-default]').length) {
					$(el).find('[data-default]').prop('selected', true);

				}
				else {
					$(el).find('[value=""]').prop('selected', true);
				}
			});

			this.applyFilters(false);
		}

		applyFilters(initial) {

			var filters = {};

			this.$filter.each((i, el) => {
				const tax = $(el).attr('name');
				const val = $(el).is('select') ? $(el).find(':selected').val() : $(el).val();

				if (val) {
					$(el).addClass('is-active');
					filters[tax] = val;
				}
				else {
					$(el).removeClass('is-active');
				}
			});

			this.$grid.attr('data-filters', JSON.stringify(filters));
			if ((initial && filters.length) || !initial) {
				this.$grid.attr('data-current-page', '0');
				this.$grid.trigger('reload');
				this.$filtersWrap.addClass('is-loading');
			}

		}
	}

})(jQuery);

var csFiltersInit$1 = csFiltersInit;

var loadmoreInit;

(function ($) {

	const selectors = {
		button: '[data-loadmore]',
	};

	loadmoreInit = function () {
		$(selectors.button).each((i, el) => {
			new LoadmoreButton(el);
		});
	};

	class LoadmoreButton {
		constructor(el) {

			this.$button = $(el);

			this.init();
			this.bind();

		}

		init() {

			this.$postWrap = $(this.$button.attr('data-wrap'));

			this.template = this.$postWrap.attr('data-template');
			this.itemClass = this.$postWrap.children().first().attr('class');
			this.disp = this.$postWrap.children().first().css('display');
			this.query_args = this.$postWrap.attr('data-query-args') ? JSON.parse(this.$postWrap.attr('data-query-args')) : false;

			this.data = {
				'action': 'loadmore',
				'query_args': this.query_args,
				'page': this.$postWrap.attr('data-current-page') ? parseInt(this.$postWrap.attr('data-current-page')) : wp_params.current_page,
				'template': this.$postWrap.attr('data-template'),
				'wrapper': this.itemClass,
				'filters': []
			};

		}

		bind() {
			this.loadmore = this.loadmore.bind(this);
			this.$button.on('click', this.loadmore);
			this.$postWrap.on('reload', this.loadmore);
		}

		loadmore(e) {
			e.preventDefault();

			const self = this;

			var currentPage = parseInt(this.$postWrap.attr('data-current-page'));
			self.data.page = currentPage;
			self.data.filters = JSON.parse(self.$postWrap.attr('data-filters'));

			$.ajax({
				url: wp_params.ajax_url, // AJAX handler
				data: self.data,
				type: 'POST',
				beforeSend: function () {
					self.$button.addClass('is-loading');
				},
				success: function (data) {

					console.log(data);

					if (currentPage == 0) {
						self.$postWrap.html(''); // do a reload
						if (!data.no_more_posts)
							self.$button.removeClass('fading no-posts').fadeIn(400);
					}

					if (!data || data.html === undefined) return;

					self.$postWrap.append(data.html);
					self.$postWrap.find('.ajax-loaded').css({ display: self.disp }).hide();
					self.$postWrap.find('.ajax-loaded').fadeIn(400).removeClass('ajax-loaded');

					self.$button.find('.loading').fadeOut();
					self.$button.removeClass('is-loading');

					self.$postWrap.attr('data-current-page', currentPage + 1);

					if (data.no_more_posts) {
						self.$button.addClass('fading').fadeOut(400);
						self.$button.removeClass('is-loading').addClass('no-posts');
					}

					$(document.body).trigger('post-load');

				}
			});

		}

	}

})(jQuery);

var loadmoreInit$1 = loadmoreInit;

var niceSelectInit;

(function ($) {

	const selectors = {
		select: 'select:not(.no-js)',
	};

	niceSelectInit = function () {
		$(selectors.select).niceSelect();
	};

})(jQuery);


var niceSelectInit$1 = niceSelectInit;

(function ($) {

	$(document).ready(function () {

		documentInit$1();
		navInit$1();
		mobileNavInit$1();
		slickInit$1();
		miscInit$1();
		csFiltersInit$1();
		loadmoreInit$1();
		niceSelectInit$1();

		$(window).trigger('resize');
		$(window).trigger('scroll');
		$(window).trigger('hp-plugins-loaded');

	});

})(jQuery);

}());
